import * as LoyaltyBonusStyles from './components/LoyaltyBonus.css';
export default {
    LoyaltyBonusStyles
};
